export enum OrdersApiEnum{
  RestaurantModule = 'rpo-m',
  Cart = 'cart',
  CartStatus = 'cart-status',
  RestaurantTable= 'table',
  FoodModule ='foo-m',
  Food = 'food',
  FoodExtra = 'food-extra',
  GetAll = 'get-all',
  Section = 'section',
  SectionTable = 'section-table',
  Order = 'order',
  CompletedOrder = 'completed-order',
  CustomerOrder = 'customer-order',
  CustomerOrderApproval = 'customer-order-approval',
  FoodItemQuantityTag = 'food-quantity-tag',
  DineIn = 'dine-in',
  Takeaway = 'takeaway',
  Delivery = 'delivery',
  Kitchen = 'kitchen',
  GetByUserId = 'get-by-user-id',
  OrderPreparationStatus ='order-preparation-status',
  DeletedOrder = 'deleted-order',
  DeletedItems = 'deleted-items',
  Restore = 'restore',
  DeletedCart = 'deleted-cart'
}
